import {
  expectedOutcome as expectedOutcomeLookup,
  timeDate as timeDateLookup,
} from 'features/legalClaims/models';
import { Claim } from 'models/claims';
import { useSafeTranslation } from 'shared/i18n';

import { ClaimCollapsibleCard } from './components/ClaimCollapsibleCard';

export const ClaimLegalDescription = ({ claim }: { claim: Claim }) => {
  const { t } = useSafeTranslation();
  const {
    claimTypes,
    claimNumber,
    timeDate,
    expectedOutcome,
    contacts: phoneNumber,
    details,
    phoneConsultation,
    hiredLawyer,
    lawyerName,
  } = claim;

  const noClaimTypes = claimTypes.length === 0;
  const isSubmittedClaim = claimTypes.every(
    (type) => type.claimType !== 'BOOK_A_CONSULTATION'
  );

  return (
    <ClaimCollapsibleCard
      title={
        noClaimTypes || isSubmittedClaim
          ? t('claims.detail.legal.claimsSubmitted.title', 'Claims submitted')
          : t('claims.detail.legal.requestSubmitted.title', 'Request submitted')
      }
    >
      <>
        {(noClaimTypes || isSubmittedClaim) && claimNumber && (
          <div className="d-flex d-row mt24 ai-center">
            <div className="w30 mr24 p-p tc-grey-500">
              {t('claims.detail.legal.claimNumber', 'Claim number')}
            </div>
            <div className="w70 p-p">{claimNumber}</div>
          </div>
        )}
        {expectedOutcome && (
          <div className="d-flex d-row mt24 ai-center">
            <div className="w30 mr24 p-p tc-grey-500">
              {t(
                'claims.detail.legal.expectedOutcome',
                'Reason for consultation'
              )}
            </div>
            <div className="w70 p-p">
              {expectedOutcomeLookup(t)[expectedOutcome]}
            </div>
          </div>
        )}
        <div className="d-flex d-row mt24 ai-center">
          <div className="w30 mr24 p-p tc-grey-500">
            {t('claims.detail.legal.eventDescription', 'What happened?')}
          </div>
          <div className="w70 p-p">{details}</div>
        </div>
        {phoneNumber && (
          <div className="d-flex d-row mt24 ai-center">
            <div className="w30 mr24 p-p tc-grey-500">
              {t('claims.detail.legal.phoneNumber', 'Phone number')}
            </div>
            <div className="w70 p-p">
              {phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`}
            </div>
          </div>
        )}
        {timeDate && (
          <div className="d-flex d-row mt24 ai-center">
            <div className="w30 mr24 p-p tc-grey-500">
              {t('claims.detail.legal.timeDate', 'Preferred time slot')}
            </div>
            <div className="w70 p-p">{timeDateLookup(t)[timeDate]}</div>
          </div>
        )}
        {phoneConsultation !== null && (
          <div className="d-flex d-row mt24 ai-center">
            <div className="w30 mr24 p-p tc-grey-500">
              {t(
                'claims.detail.legal.phoneConsultation.title',
                'Had a phone consultation?'
              )}
            </div>
            <div className="w70 p-p">
              {phoneConsultation
                ? t('claims.detail.legal.phoneConsultation.yes', 'Yes')
                : t('claims.detail.legal.phoneConsultation.no', 'No')}
            </div>
          </div>
        )}
        {hiredLawyer !== null && hiredLawyer !== undefined && (
          <div className="d-flex d-row mt24 ai-center">
            <div className="w30 mr24 p-p tc-grey-500">
              {t('claims.detail.legal.hiredLawyer.title', 'Hired a lawyer?')}
            </div>
            <div className="w70 p-p">
              {hiredLawyer
                ? t('claims.detail.legal.hiredLawyer.yes', 'Yes')
                : t('claims.detail.legal.hiredLawyer.no', 'No')}
            </div>
          </div>
        )}
        {lawyerName && (
          <div className="d-flex d-row mt24 ai-center">
            <div className="w30 mr24 p-p tc-grey-500">
              {t('claims.detail.legal.lawyerName', 'Lawyer name')}
            </div>
            <div className="w70 p-p">{lawyerName}</div>
          </div>
        )}
      </>
    </ClaimCollapsibleCard>
  );
};
